export class KanaConstants {
  public static readonly KANA_HELP_URL = "https://www.kana.earth/help";
}
